import React from 'react';
import { FadeUp } from './FadeUp';
export function Agitation() {
  const cards = [{
    num: '01',
    title: 'No activity, no trust',
    desc: "When someone lands on your profile and sees no engagement, they unconsciously assume your brand isn't relevant. And they leave."
  }, {
    num: '02',
    title: 'No trust, no sales',
    desc: "Buying decisions on social media happen in seconds. If your profile doesn't project authority in those seconds, the opportunity is gone."
  }, {
    num: '03',
    title: 'The algorithm penalizes you too',
    desc: 'Instagram prioritizes content with real interaction signals. An inactive-looking account reaches fewer people — regardless of how good the content is.'
  }];
  return <section id="agitacion" className="bg-bg-secondary border-y border-cyan/10 text-center relative z-10 py-[72px] md:py-[100px]" data-id="element-21">
      <div className="max-w-[900px] mx-auto px-6" data-id="element-22">
        <p className="inline-block text-[11px] font-heading font-bold tracking-[0.25em] uppercase text-cyan mb-4" data-id="element-23">
          The real issue
        </p>

        <FadeUp data-id="element-24">
          <h2 className="text-[clamp(20px,3vw,28px)] font-heading font-bold uppercase tracking-[0.05em] max-w-[680px] mx-auto mb-6 leading-[1.4]" data-id="element-25">
            This isn't a content problem.
            <br data-id="element-26" />
            It's a <span className="text-cyan" data-id="element-27">perception problem.</span>
          </h2>
        </FadeUp>

        <FadeUp delay={0.1} data-id="element-28">
          <p className="text-white-dim text-[17px] max-w-[580px] mx-auto mb-14" data-id="element-29">
            On Instagram, perception and reality are the same thing. If your
            account doesn't show signs of activity, people don't trust it — and
            the algorithm won't push it. It's a cycle that only breaks from the
            inside.
          </p>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-30">
          {cards.map((card, i) => <FadeUp key={i} delay={i * 0.08} data-id="element-31">
              <div className="bg-bg-card border border-cyan/10 rounded-sm p-[30px_24px] text-left transition-all duration-300 ease-in hover:border-cyan/40 card-glow-hover-lg hover:-translate-y-[3px] h-full" data-id="element-32">
                <div className="text-[12px] font-heading font-bold text-blue-electric tracking-[0.2em] uppercase mb-4 opacity-80" data-id="element-33">
                  {card.num}
                </div>
                <h3 className="text-[15px] font-heading font-semibold uppercase tracking-[0.05em] mb-3" data-id="element-34">
                  {card.title}
                </h3>
                <p className="text-[14px] text-white-dim leading-[1.6]" data-id="element-35">
                  {card.desc}
                </p>
              </div>
            </FadeUp>)}
        </div>
      </div>
    </section>;
}